import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { LoadingService } from '../../core/services/app-loading.service';

@Component({
  standalone: true,
  imports: [],
  selector: 'app-spinner',
  templateUrl: './spinner.html',
  styleUrl: './spinner.scss',
})
export class Spinner {
  readonly loadingService = inject(LoadingService);
}
